import React from "react";
import { FiLoader, FiFlag, FiTarget, FiDownload } from "react-icons/fi";
import { formatValue } from "../utils";

const SummaryCards = ({ cards, loading, navigate, selectedProcess, dashboard, selectedMonth, selectedYear }) => {
  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
      {cards.map((card) => {
        const actual = card.metrics[0]?.value || 0;
        const baseline = card.metrics[1]?.value || 0;
        const target = card.metrics[2]?.value || 0;

        const variance =
          target !== 0
            ? (((actual - target) / target) * 100).toFixed(0)
            : 0;

        return (
          <div
            key={card.title}
            className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition hover:shadow-md"
          >
            {/* Top Section */}
            <div
              className={`cursor-pointer p-6 text-white ${card.accent}`}
              onClick={() =>
                navigate("/Insights/eda-segment-detail", {
                  state: {
                    selectedProcess,
                    dashboard,
                    segment: card.title,
                    month: selectedMonth,
                    year: selectedYear,
                  },
                })
              }
            >
              {/* Header */}
              <div className="mb-3 flex items-center gap-2">
                <span className="text-sm opacity-80">{card.icon}</span>

                <span className="text-lg font-semibold uppercase tracking-wide">
                  {card.title}
                </span>
              </div>

              {/* Actual */}
              <div className="mb-1">
                <div className="flex items-baseline gap-2">
                  {loading ? (
                    <>
                      <FiLoader className="h-8 w-8 animate-spin opacity-80" />
                      <span className="text-lg opacity-80">
                        Loading...
                      </span>
                    </>
                  ) : (
                    <>
                      <div className="text-4xl font-bold leading-none">
                        {formatValue(actual)}
                      </div>
                      <div className="text-2xl opacity-90">
                        Cr / month
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Bottom Section */}
            <div className="space-y-3 p-4">
              <div className="flex items-center justify-between rounded-xl bg-slate-50 px-4 py-3">
                <div className="flex items-center gap-3">
                  <FiFlag className="h-5 w-5 text-slate-500" />
                  <span className="text-lg text-slate-700">
                    Baseline per month
                  </span>
                </div>

                {loading ? (
                  <FiLoader className="h-5 w-5 animate-spin text-slate-500" />
                ) : (
                  <span className="text-xl font-medium text-slate-700">
                    {formatValue(baseline)}
                    <span className="text-base text-slate-500"> Cr</span>
                  </span>
                )}
              </div>

              <div className="flex items-center justify-between rounded-xl bg-slate-50 px-4 py-3">
                <div className="flex items-center gap-3">
                  <FiTarget className="h-5 w-5 text-slate-500" />
                  <span className="text-lg text-slate-700">
                    Target per month
                  </span>
                </div>

                {loading ? (
                  <FiLoader className="h-5 w-5 animate-spin text-slate-500" />
                ) : (
                  <span className="text-xl font-medium text-slate-700">
                    {formatValue(target)}
                    <span className="text-base text-slate-500"> Cr</span>
                  </span>
                )}
              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-between border-t border-slate-200 px-5 py-4">
              <p className="text-sm text-slate-400">
                Click card to open BP summary
              </p>

              {card.xlsLink && (
                <a
                  href={card.xlsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-xl border border-emerald-400 px-4 py-2 text-sm font-medium text-emerald-700 transition hover:bg-emerald-50"
                >
                  <FiDownload className="h-4 w-4" />
                  Download ↗
                </a>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SummaryCards;
